/** Shown in place of a paired record's code/number while its query is still loading. */
export const PAIRED_RECORD_LOADING_PLACEHOLDER = '…';
